<p-toast position="bottom-right"></p-toast>
<p-confirmDialog appendTo="body"></p-confirmDialog>
<app-cc-table #ccTable [transPartKey]="transPartKey"
              [tableConfig]="tableConfig" [headerButtonConfig]="headerButtonConfig" [footerButtonConfig]="footerButtonConfig"
              [contextMenuConfig]="contextMenuConfig" [(selectedRecord)]="formRecord" (selectedRecordChange)="formRecordChange.emit($event)"
              [(selectedRecords)]="selectedRecords" (selectedRecordsChange)="selectedRecordsChange.emit($event)"
              [records]="records" [totalRecords]="totalRecords" [loading]="tableLoading" [currentRequest]="tableCurrentRequest"
              (onRowDblClick)="onRowDblClick($event)" (loadRecordsEvent)="loadRecords($event)"
              [fieldName]="fieldName" [fieldId]="fieldId" [fieldEnabled]="fieldEnabled" (selectionchange)="selectionChange.emit($event)"
              [defaultSortOrder]="defaultSortOrder" [defaultSortField]="defaultSortField"
              [selectionMode]="isReadOnly?'single':'multiple'" [lazyLoadOnInit]="lazyLoadOnInit"
              [reorderableRows]="reorderableRows" (rowOrderChanged)="rowOrderChanged.emit($event)"
              (onContextMenuShow)="refreshContextMenu(); onContextMenuShow.emit(contextMenuConfig)"
              (onClearFilter)="onClearTableFilter.emit($event)" [disableFilters]="disableFilters"
>
  <ng-content toolbar-left select="[table-toolbar-left]"></ng-content>
  <ng-content toolbar-center select="[table-toolbar-center]"></ng-content>
  <ng-content toolbar-right select="[table-toolbar-right]"></ng-content>
  <ng-content paginatorright-content select="[paginatorright-content]"></ng-content>
</app-cc-table>

<app-cc-form-dialog #ccFormDialog *ngIf="!isReadOnly" [transPartKey]="transPartKey" [fieldName]="fieldName"
                    [loading]="formLoading" [submitted]="formSubmitted"
                    [(dialogFormVisible)]="dialogFormVisible"
                    (dialogFormVisibleChange)="dialogFormVisibleChange.emit($event)"
                    [formConfig]="formConfig" [dialogFormTitle]="dialogFormTitle"
                    [(formRecord)]="formRecord" (onSubmitEvent)="save()"
                    [loadingProgressValue]="settingsFormLoadingProgressValue"
                    [disableSubmitButton]="!fieldValueMap['validate']" [globalErrorMessage]="globalErrorMessage"
                    [globalInfoMessage]="globalInfoMessage"
                    [dialogClass]="dialogClass+' crude-form-dialog'" (formRecordChange)="reloadFieldValueMap()"
>
  <ng-content footer-left select="[dialog-footer-left]"></ng-content>
  <ng-content footer-right select="[dialog-footer-right]"></ng-content>
</app-cc-form-dialog>
<app-cc-detail-dialog *ngIf="isReadOnly" [transPartKey]="transPartKey" [fieldName]="fieldName"
                      [(dialogFormVisible)]="dialogFormVisible"
                      [formConfig]="formConfig"
                      [formRecord]="formRecord"
></app-cc-detail-dialog>

